import axios from 'axios'

export default {
    /**
     * Get all coupons with optional filters
     * @param {string} search Search query
     * @param {number} page Page number
     * @param {number} perPage Items per page
     * @param {string} sortColumn Column to sort by
     * @param {string} order Sort order (ASC/DESC)
     * @returns {Promise} API response
     */
    getAllCoupons(search = '', page = 1, perPage = 10, sortColumn = '', order = '') {
        return axios.get('/api/coupons', {
            params: {
                search,
                page,
                per_page: perPage,
                sort_by: sortColumn,
                sort_dir: order
            }
        })
    },

    /**
     * Get a specific coupon by ID
     * @param {string} id Coupon ID
     * @returns {Promise} API response
     */
    getCoupon(id) {
        return axios.get(`/api/coupons/${id}/show`)
    },

    /**
     * Create a new coupon
     * @param {Object} data Coupon data
     * @returns {Promise} API response
     */
    createCoupon(data) {
        return axios.post('/api/coupons', data)
    },

    /**
     * Update an existing coupon
     * @param {string} id Coupon ID
     * @param {Object} data Updated coupon data
     * @returns {Promise} API response
     */
    updateCoupon(id, data) {
        return axios.patch(`/api/coupons/${id}/update`, data)
    },

    /**
     * Delete a coupon
     * @param {string} id Coupon ID
     * @returns {Promise} API response
     */
    deleteCoupon(id) {
        return axios.delete(`/api/coupons/${id}/destroy`)
    },

    /**
     * Apply a coupon code
     * @param {Object} data Data containing coupon code and order total
     * @returns {Promise} API response
     */
    applyCoupon(data) {
        return axios.post('/api/coupons/apply', data)
    },

    /**
     * Validate a coupon code
     * @param {Object} data Data containing coupon code
     * @returns {Promise} API response
     */
    validateCoupon(data) {
        return axios.post('/api/coupons/validate', data)
    }
}
